import React from 'react';
import {Form, Input, Select, Col, Row, InputNumber, message, DatePicker, Radio} from 'antd';
import Cookies from 'js-cookie';
import ModalDom from '../../../../components/Modal';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import { dicPayType } from '../../../../axios/dictionaries';
import moment from 'moment';

const Option = Select.Option;

const { MonthPicker } = DatePicker;

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            title: "编辑优惠券",
            radioLessReliefTypeValue:false,
            data: {
                houseLayout: []
            },
        }

        postFrom({ url: config.API_dictionary_findList, data: { groupName: '收款类别' } }).then(res => {
            this.setState({ receivablesType: res });
        }).catch(err => {
            message.error(err.message || '获取收款类别失败');
        });

        postFrom({ url: config.API_project_findProjectPageList, data: { pageSize: 200 } }).then(res => {
            console.log(res.records);
            this.setState({ projectList: res.records });
        }).catch(err => {
            message.error(err.message || '获取收款类别失败');
        });
    }

    handleLessReliefTypeChange = (e) => { // 最低减免类型
        const radioLessReliefTypeValue = e.target.value
        this.setState({
            radioLessReliefTypeValue
        })
    }

    render() {
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
            receivablesType=[],
            projectList=[],
        } = this.state;

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    {getFieldDecorator('id', {
                        initialValue: data.id
                    })(
                        <Input type={'hidden'} />
                    )}
                    <Row>
                        <Col span={24}>
                            <CustomRow>
                                <CustomCol label="优惠券名称">
                                    {getFieldDecorator('couponName', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.couponName
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="账单费项">
                                    {getFieldDecorator('feeName', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.feeName
                                    })(
                                        <Select
                                            placeholder="请选择"
                                        >
                                            {receivablesType.map((item, index) => <Option value={item.dicValue} key={index}>{item.dicValue}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>

                            <CustomRow divider>
                                <CustomCol label="支付方式">
                                    {getFieldDecorator('payType', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.payType
                                    })(
                                        <Select
                                            placeholder="请选择"
                                        >
                                            {dicPayType.filter(item => (item.value ===3)||(item.value ===7)).map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="减免金额" >
                                    {getFieldDecorator('creditAmount', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.creditAmount
                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            min={0}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>


                            <CustomRow divider>
                                <CustomCol label="生效月份" >
                                    {getFieldDecorator('mustPayDate', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.mustPayDate?moment(data.mustPayDate):null
                                    })(
                                       <MonthPicker  picker="month" format={"YYYY-MM"}/>
                                    )}
                                </CustomCol>
                                <CustomCol label="最低触发金额">
                                    {getFieldDecorator('minFeeNameAmount', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.minFeeNameAmount
                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            min={0}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>

                            {/*<CustomRow divider>*/}
                            {/*    <CustomCol label="大于等于金额" >*/}
                            {/*        {getFieldDecorator('greaterEqualBillMoney', {*/}
                            {/*            rules: [{*/}
                            {/*                required: true, message: '请输入大于等于账单金额值',*/}
                            {/*            }],*/}
                            {/*            initialValue: data.greaterEqualBillMoney*/}
                            {/*        })(*/}
                            {/*            <InputNumber*/}
                            {/*                placeholder={'请输入大于等于账单金额值'}*/}
                            {/*                autoComplete={'off'}*/}
                            {/*                min={0}*/}
                            {/*            />*/}
                            {/*        )}*/}
                            {/*    </CustomCol>*/}

                            {/*    <CustomCol label="减免金额" >*/}
                            {/*        {getFieldDecorator('greaterEqualBillCreditAmount', {*/}
                            {/*            rules: [{*/}
                            {/*                required: true, message: '请输入',*/}
                            {/*            }],*/}
                            {/*            initialValue: data.greaterEqualBillCreditAmount*/}
                            {/*        })(*/}
                            {/*            <InputNumber*/}
                            {/*                placeholder={'请输入大于等于账单金额值减免金额值'}*/}
                            {/*                autoComplete={'off'}*/}
                            {/*                min={0}*/}
                            {/*            />*/}
                            {/*        )}*/}
                            {/*    </CustomCol>*/}
                            {/*</CustomRow>*/}

                            {/*<CustomRow divider>*/}
                            {/*    <CustomCol label="小于金额" >*/}
                            {/*        {getFieldDecorator('lessBillMoney', {*/}
                            {/*            rules: [{*/}
                            {/*                required: true, message: '请输入',*/}
                            {/*            }],*/}
                            {/*            initialValue: data.lessBillMoney*/}
                            {/*        })(*/}
                            {/*            <InputNumber*/}
                            {/*                placeholder={'请输入'}*/}
                            {/*                autoComplete={'off'}*/}
                            {/*                min={0}*/}
                            {/*            />*/}
                            {/*        )}*/}
                            {/*    </CustomCol>*/}


                            {/*</CustomRow>*/}

                            {/*<CustomRow divider>*/}
                            {/*    <CustomCol label="小于减免类型" >*/}
                            {/*        {getFieldDecorator('lessReliefType', {*/}
                            {/*            rules: [{*/}
                            {/*                required: true, message: '请输入',*/}
                            {/*            }],*/}
                            {/*            initialValue: data.lessReliefType*/}
                            {/*        })(*/}
                            {/*            <Radio.Group onChange={this.handleLessReliefTypeChange}>*/}
                            {/*                <Radio value={false}>固定减免</Radio>*/}
                            {/*                <Radio value>最低支付金额</Radio>*/}
                            {/*            </Radio.Group>*/}
                            {/*        )}*/}
                            {/*    </CustomCol>*/}
                            {/*</CustomRow>*/}
                            {/*<CustomRow divider>*/}
                            {/*    <CustomCol label="减免金额" >*/}
                            {/*        {getFieldDecorator('lessBillCreditAmount', {*/}
                            {/*            rules: [{*/}
                            {/*                required: true, message: '请输入大于等于账单金额值减免金额值',*/}
                            {/*            }],*/}
                            {/*            initialValue: data.lessBillCreditAmount*/}
                            {/*        })(*/}
                            {/*            <InputNumber*/}
                            {/*                placeholder={'请输入小于账单金额值减免金额值'}*/}
                            {/*                autoComplete={'off'}*/}
                            {/*                min={0}*/}
                            {/*            />*/}
                            {/*        )}*/}
                            {/*    </CustomCol>*/}
                            {/*    <CustomCol label="最低支付金额" >*/}
                            {/*        {getFieldDecorator('minPaymentAmount', {*/}
                            {/*            rules: [{*/}
                            {/*                required: true, message: '请输入大于等于账单金额值减免金额值',*/}
                            {/*            }],*/}
                            {/*            initialValue: data.minPaymentAmount*/}
                            {/*        })(*/}
                            {/*            <InputNumber*/}
                            {/*                placeholder={'请输入小于账单金额值减免金额值'}*/}
                            {/*                autoComplete={'off'}*/}
                            {/*                min={0}*/}
                            {/*            />*/}
                            {/*        )}*/}
                            {/*    </CustomCol>*/}
                            {/*</CustomRow>*/}

                            <CustomRow divider>
                                <CustomCol label="归属项目" colStyle={{ width: '500px', height: 'auto' }}>
                                    {getFieldDecorator('projectIds', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.projectIds
                                    })(
                                        <Select
                                            mode="multiple"
                                            style={{ width: '100%' }}
                                            placeholder="请选择归属项目"
                                        >
                                            {projectList.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)}
                                        </Select>,
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }



    handleCancel = () => { //关闭页面
        this.props.handleCancel();

        this.setState({ data: {}, loading: false, title: "新增优惠劵" });
    }

    initPack = () => {
        this.forceUpdate();
    }

    loadPack = ({ id }) => {
        this.setState({ loading: true, title: "编辑优惠券" });
        postFrom({ url: config.API_coupon_getById+"?discountCouponId="+id, data: { } }).then(res => {
            this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });


    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                let loginData = Cookies.get('loginData');
                if (loginData) {
                    loginData = JSON.parse(loginData);
                    values.merchantId = loginData.merchantId ? loginData.merchantId : 0;
                } else {
                    message.error('未登录')
                    return
                }

                values.mustPayDate=moment(values.mustPayDate).format("YYYY-MM")

                this.setState({ loading: true });

                if (values.id) {
                    post({ url: config.API_coupon_edit, data: values }).then(res => {
                        message.success('编辑成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '编辑失败');
                        this.setState({ loading: false });
                    })
                } else {
                    post({ url: config.API_coupon_create, data: values }).then(res => {
                        message.success('新增成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '新增失败');
                        this.setState({ loading: false });
                    })
                }
            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Coupons/components/ListAdd/index.js